export const colors = {
    primary: {
      main: '#1367B1',
      light: '#4B9FE1',
      dark: '#0D4C8C',
    },
    secondary: {
      main: '#454545',
      light: '#6E6E6E',
      dark: '#2C2C2C',
    },
    background: {
      default: '#F3F4F6',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#454545',
      secondary: '#6E6E6E',
    },
    border: {
      main: '#E5E7EB',
      light: '#F3F4F6',
    }
  };